var map = {
	"./logo-alphabet.svg": 500,
	"./logo-amazon-2.svg": 501,
	"./logo-amazon.svg": 494,
	"./logo-azercell.svg": 512,
	"./logo-bank-of-america.svg": 489,
	"./logo-barclays.svg": 485,
	"./logo-bnp-paribas.svg": 486,
	"./logo-booking.svg": 490,
	"./logo-citibank.svg": 480,
	"./logo-coca-cola.svg": 523,
	"./logo-deloitte.svg": 524,
	"./logo-experian.svg": 525,
	"./logo-facebook.svg": 526,
	"./logo-goldman-sacks.svg": 488,
	"./logo-google.svg": 527,
	"./logo-h.svg": 528,
	"./logo-infineon.svg": 529,
	"./logo-instagram.svg": 530,
	"./logo-jp-morgan.svg": 487,
	"./logo-jti.svg": 516,
	"./logo-linkedin.svg": 531,
	"./logo-meta.svg": 502,
	"./logo-oracle.svg": 483,
	"./logo-paypal.svg": 481,
	"./logo-pwc.svg": 532,
	"./logo-tesla.svg": 482,
	"./logo-visa.svg": 495,
	"./logo-walmart.svg": 474,
	"./logo-youtube.svg": 533
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 520;